var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(!_vm.isHidden) ? _c('of-label', {
    attrs: {
      "text": _vm.label
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    class: _vm.inputGroup.class
  }, [(_vm.addOns && _vm.addOns.left) ? _c('of-add-on', {
    attrs: {
      "html": _vm.addOns.left
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "component",
      rawName: "v-component",
      value: (_vm.options),
      expression: "options"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "placeholder": _vm.input.placeholder,
      "readonly": _vm.input.readonly || false,
      "type": _vm.input.type
    },
    domProps: {
      "value": _vm.formatted
    },
    on: {
      "change": function (event) { return _vm.input.change && _vm.input.change(event); },
      "click": function (event) { return _vm.input.click && _vm.input.click(event); },
      "focus": function (event) { return _vm.input.focus && _vm.input.focus(event); },
      "focusout": function (event) { return _vm.input.focusout && _vm.input.focusout(event); },
      "input": function (event) { return _vm.input.input && _vm.input.input(event); }
    }
  }), _vm._v(" "), (_vm.addOns && _vm.addOns.right) ? _c('of-add-on', {
    attrs: {
      "html": _vm.addOns.right
    }
  }) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ecfdd2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/input/Input.vue
// module id = 522
// module chunks = 1